import { gql } from "@apollo/client";
import { Customer } from "../../fragments";

export const UPDATE_PROFILE = gql`
  mutation UpdateProfileInformation($input: UpdateProfileInformationInput!) {
    result: updateProfileInformation(input: $input) {
      errors {
        message
        field
      }
      customer {
        ...Customer
      }
    }
  }
  ${Customer}
`;
